"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateUtil = void 0;
var moment_1 = __importDefault(require("moment"));
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var constants_1 = __importDefault(require("../constants"));
exports.DateUtil = {
    formatDateToLocal: function (dateVal, format) {
        if (!dateVal) {
            return '';
        }
        format = format || constants_1.default.DATE_FORMAT_LONG;
        return exports.DateUtil.getLocalMoment(dateVal).format(format);
    },
    getLocalMoment: function (dateVal) {
        var date = (0, moment_timezone_1.default)(dateVal);
        return date.tz(moment_timezone_1.default.tz.guess());
    },
    getUtcDateTime: function (dateVal) {
        var utcDate = moment_1.default.utc(dateVal).format();
        return utcDate;
    },
};
